module.exports = __webpack_public_path__ + "static/media/NISSIN.c15fe50e.mp4";